import script from "./ArrivalChartView.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrivalChartView.vue?vue&type=script&setup=true&lang=js"

import "./ArrivalChartView.vue?vue&type=style&index=0&id=0a71591d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a71591d"]])

export default __exports__